import { ElementRef, EventEmitter, Inject, Injectable, NgZone } from '@angular/core';
// import * as io from "socket.io-client";
// @ts-ignore
import { io } from 'socket.io-client';

import * as cee from './Common/CeeEnvisionWebComponents';

interface Env {
  production: boolean;
  C3SERVER: string;
  USIM_HOST: string;
  deployment: string;
  TOKEN: string;
  APP: string;
  clientId: string;
  grantType: string;
  scope: string;
  resourceServer: string;
  responseType: string;
  googleAuthurl: string;
  authorization_endpoint: string;
  federationServiceConfigUrl: string;
  federation_attribute: string;
  redirectUri: string;
  getTokenUrl: string;
}

// cee::ug8
@Injectable()
export class C3Service {
  public elementPicked = Object();
  public meshPicked = Object();

  private _socket = Object();
  private _session = Object();
  // private _viewer: cee.Viewer;
  public _viewer = Object();
  // private _view: cee.View;
  public _view = Object();
  // private _model: cee.ug.RemoteModel;
  public _model = Object();

  private _displacementResults!: ReadonlyArray<cee.ug.ResultInfo>;
  private _displacementResultsWithNone!: ReadonlyArray<cee.ug.ResultInfo>;
  // private m_markupModel!;
  private observeModel = Object();

  // private _session: cee.CloudSession;
  // private _viewer: cee.Viewer;
  // private _view: cee.View;
  // private _model: cee.ug.RemoteModel;
  private _scalarResults = Object();
  private _vectorResults = Object();
  private _scalarResultsWithNone = Object();
  private _vectorResultsWithNone = Object();
  private _states!: ReadonlyArray<cee.ug.StateInfo>;
  private _resultChangedHandlers: Array<() => void> = [];
  private _pickHandler!: (hitItem: cee.ug.HitItem) => void;
  private m_markupModel!: any;

  public get viewer() {
    return this._viewer;
  }
  public get view() {
    return this._view;
  }
  public get model() {
    return this._model;
  }

  public get scalarResults() {
    return this._scalarResults;
  }
  public get vectorResults() {
    return this._vectorResults;
  }
  public get displacementResults() {
    return this._displacementResults;
  }
  public get scalarResultsWithNone() {
    return this._scalarResultsWithNone;
  }
  public get vectorResultsWithNone() {
    return this._vectorResultsWithNone;
  }
  public get displacementResultsWithNone() {
    return this._displacementResultsWithNone;
  }
  public get states() {
    return this._states;
  }
  public get markupModel() {
    return this.m_markupModel;
  }

  constructor(
    private zone: NgZone,
    @Inject('environment') private environment: Env
  ) {
    this.environment = environment;
  }

  public initialize(canvasRef: HTMLElement, containerRef: HTMLElement, modelId: string) {
    // Construct the URL to the C3Server
    // const c3Port = helpers.getURLParameter("ugServerPort") || 8998;
    // const protocol = window.location.protocol === "https:" ? "https://" : "http://";
    // const vizServerUrl = protocol + (window.location.hostname ? window.location.hostname : "localhost") + ":" + c3Port;
    //const vizServerUrl = "http://usimweb1.f206.basf-ag.de:8998";
    const vizServerUrl = this.environment.C3SERVER;

    console.log('Connecting to CeeCloudServer using url: ' + vizServerUrl);

    const socket = io(vizServerUrl);
    this._socket[modelId] = socket;
    // const socket = io(vizServerUrl, {
    //     reconnectionDelayMax: 10000,
    // });

    // socket.connect();
    // const socket = io.connect(vizServerUrl, {reconnection: false});

    // @ts-ignore
    socket.on('connect_error', (err) => {
      socket.disconnect();
      console.log('error');
      console.log(err);
      alert('Error with connection to CeeCloudServer. Check that you have a server running on: ' + vizServerUrl);
      return;
    });

    this.elementPicked[modelId] = new EventEmitter<cee.ug.HitItem>();
    this.meshPicked[modelId] = new EventEmitter<cee.geo.MeshHitItem>();

    this._session[modelId] = new cee.CloudSession();

    const container = containerRef;
    const canvas = canvasRef;
    this._viewer[modelId] = this._session[modelId].addViewer(canvas);

    // const container: HTMLElement = containerRef.nativeElement;
    // const canvas: HTMLCanvasElement = canvasRef.nativeElement;
    // this._viewer = this._session.addViewer(canvas);
    if (!this._viewer[modelId]) {
      alert('No WebGL support');
      return;
    }

    this._viewer[modelId].resizeViewer(650, 400);
    this._view[modelId] = this._viewer[modelId].addView();

    const viewer = new cee.CloudSession();

    const navigation = this._viewer[modelId].getViewAt(0).navigation;

    console.log('navigation');
    console.log(navigation);

    const overlay = this._viewer[modelId].getViewAt(0).overlay;

    console.log('overlay');
    console.log(overlay);

    // this._view[modelId].backgroundColor = new cee.Color3(1, 1, 1);
    this._view[modelId].haloHighlightColor = new cee.Color3(0, 0, 0);
    // this._view[modelId].overlay.infoBoxVisible = false;

    this._model[modelId] = new cee.ug.RemoteModel(socket);
    this._view[modelId].addModel(this._model[modelId]);
    this.observeModel[modelId] = false;

    // this.zone.runOutsideAngular(() => {
    // Setup timer to keep the WebViz viewer up-to-date
    const myAnimationFrameCallback = (highResTimestamp: number) => {
      this._session[modelId].handleAnimationFrameCallback(highResTimestamp);
      if (this.environment.APP === 'mapper') {
        if (this.observeModel[modelId]) {
          const camera = this._viewer[modelId].getViewAt(0).camera;

          camera.setViewChangeHandler((view: cee.CameraViewChangeHandler) => {
            for (const modelKey in this._viewer) {
              if (modelId !== modelKey) {
                // order in eye, dir, up
                this._viewer[modelKey].getViewAt(0).camera.setViewpoint(camera.getPosition(), camera.getDirection(), camera.getUp());
              }
            }
          }, true);
        }
        if (this._view[modelId]) {
          this._view[modelId].requestRedraw();
          requestAnimationFrame(myAnimationFrameCallback);
        }
      } else {
        requestAnimationFrame(myAnimationFrameCallback);
      }
    };

    requestAnimationFrame(myAnimationFrameCallback);
    // });

    // Setup timer to keep the WebViz viewer up-to-date
    // const myAnimationFrameCallback = (highResTimestamp: number) => {
    //     this._session[modelId].handleAnimationFrameCallback(highResTimestamp);
    //     requestAnimationFrame(myAnimationFrameCallback);
    // };

    // requestAnimationFrame(myAnimationFrameCallback);

    this._model[modelId].setResultRangeChangedHandler(() => this._resultChangedHandlers.forEach((handler) => handler()));

    this._viewer[modelId].setPickHandler((data: { ray: undefined; modifiers: cee.KeyboardModifiers }) => {
      this._model[modelId].rayIntersect(0, data.ray, (result: cee.ug.RayIntersectResult) => this.handlePick(result, data.modifiers, modelId));
    });

    this._viewer[modelId].setActiveMouseNavigationsChangedHandler(() => {
      // enable and disable model observation
      this.observeModel[modelId] = !this.observeModel[modelId];
    });
  }

  // public cameraViewChangeHandler(handler: () => cee.CameraViewChangeHandler) {
  //   console.log('camera view change handler');
  // }

  public addResultRangeChangedHandler(handler: () => void) {
    this._resultChangedHandlers.push(handler);
  }

  public performPick(handler: (hitItem: cee.ug.HitItem) => void) {
    this._pickHandler = handler;
  }

  public removePick() {
    this._pickHandler = null as any;
  }

  public showAllParts() {
    this.model.getPartSettingsArray().forEach((p: { visible: boolean }) => (p.visible = true));
  }

  public dummy() {}

  public setDrawStyleAllParts(drawStyle: cee.ug.DrawStyle, opacity?: number) {
    this.model.setDrawStyleAllParts(drawStyle);
    if (opacity !== undefined) {
      this.model.getPartSettingsArray().forEach((p: { opacity: number }) => (p.opacity = opacity));
    }
  }

  public initModel(modelId: string) {
    this._scalarResults = this._model[modelId].modelDirectory.scalarResultArray;
    this._vectorResults = this._model[modelId].modelDirectory.vectorResultArray;
    this._displacementResults = this._model[modelId].modelDirectory.displacementResultArray;
    this._scalarResultsWithNone = [{ id: -1, name: 'None' } as cee.ug.ResultInfo, ...this._scalarResults];
    this._vectorResultsWithNone = [{ id: -1, name: 'None' } as cee.ug.ResultInfo, ...this._vectorResults];
    this._displacementResultsWithNone = [{ id: -1, name: 'None' } as cee.ug.ResultInfo, ...this._displacementResults];

    this._states = this._model[modelId].modelDirectory.stateInfoArray;

    //this.setDefaults(modelId, type);
  }

  public initMapperModel(modelId: string, type?: string) {
    // console.log('init model');
    // console.log(modelId);

    this._scalarResults[modelId] = this._model[modelId].modelDirectory.scalarResultArray;
    this._vectorResults[modelId] = this._model[modelId].modelDirectory.vectorResultArray;
    this._displacementResults = this._model[modelId].modelDirectory.displacementResultArray;

    this._scalarResults[modelId] = this._scalarResults[modelId].filter((x: any) => !x['idString'].includes('WELDLINE') && !x['idString'].includes('SHRINKAGE'));
    this._vectorResults[modelId] = this._vectorResults[modelId].filter((x: any) => !x['idString'].includes('WELDLINE') && !x['idString'].includes('SHRINKAGE'));

    this._scalarResultsWithNone[modelId] = [{ id: -1, name: 'None', idString: '' } as cee.ug.ResultInfo, ...this._scalarResults[modelId]];
    this._vectorResultsWithNone[modelId] = [{ id: -1, name: 'None', idString: '' } as cee.ug.ResultInfo, ...this._vectorResults[modelId]];
    this._displacementResultsWithNone = [{ id: -1, name: 'None' } as cee.ug.ResultInfo, ...this._displacementResults];

    this._states = this._model[modelId].modelDirectory.stateInfoArray;

    // for injection point
    this.m_markupModel = new cee.mrk.MarkupModel();
    this._view[modelId].addModel(this.m_markupModel);

    // // for setting fiber orientation vector
    // for (const vector of this._vectorResults[modelId]) {
    //   // console.log('vector name');
    //   // console.log(vector.name);

    //   if (vector.name === 'fiberorientation_1') {
    //     this._model[modelId].modelSpec.vectorResultIdArray = [vector.id];
    //     this._model[modelId].getVectorSettingsAt(0).colorMode = 1;
    //     this._model[modelId].getVectorSettingsAt(0).scaleFactor = 0.05;
    //     this._model[modelId].getVectorSettingsAt(0).drawSkipBy = 4;
    //     // console.log(this._model[modelId].getVectorSettingsAt(0).getAsProperties());
    //     this._model[modelId].getVectorSettingsAt(0).getAsProperties().enableClamping = true;
    //   }
    // }

    this._scalarResultsWithNone[modelId] = this._scalarResultsWithNone[modelId].filter(
      (x: any) => !x['idString'].includes('.X') && !x['idString'].includes('.Y') && !x['idString'].includes('.Z') && !x['idString'].includes('.ALL')
    );

    //console.log('scalar results');
    // console.log(modelId);
    //console.log(this._scalarResultsWithNone);

    //console.log('vector results');
    //console.log(this._vectorResultsWithNone);
    // console.log(this._vectorResults);

    // for setting scalar and opacity
    // for (const scalar of this._scalarResultsWithNone[modelId]) {
    //   console.log('scalar name');
    //   console.log(scalar.name);

    //   if (scalar.name === 'matcherror') {
    //     this._model[modelId].modelSpec.fringesResultId = scalar.id;
    //     const part = this._model[modelId].getPartSettingsAt(0);
    //     part.opacity = 0.3;
    //   }
    // }

    this.setDefaults(modelId, type);
  }

  private handlePick(result: cee.ug.RayIntersectResult, modifiers: cee.KeyboardModifiers, modelId: string) {
    if (this._pickHandler) {
      this._pickHandler(result.hitItem);
      this._pickHandler = null as any;
    } else {
      this.defaultHandlePick(result, modifiers, modelId);
    }
  }

  private defaultHandlePick(result: cee.ug.RayIntersectResult, modifiers: cee.KeyboardModifiers, modelId: string) {
    const hitItem = result.hitItem;

    if (modifiers.shift) {
      if (hitItem.anythingHit && hitItem.objectType === cee.ug.ObjectType.PART) {
        const part = this.model.getPartSettingsAt(hitItem.objectIndex);
        if (part) {
          part.visible = false;
        }
      }
    } else {
      this.elementPicked[modelId].next(hitItem);
      this.meshPicked[modelId].next(hitItem);
    }
  }

  public setDefaultResult = true;

  public setScalarResult(modelId: string, id: number) {
    this._model[modelId].modelSpec.fringesResultId = id;
  }

  public setVectorResult(modelId: string, id: number) {
    this._model[modelId].modelSpec.vectorResultIdArray = [id];
    const vectorSettings = this._model[modelId].getVectorSettingsAt(0);
    vectorSettings.scaleFactor = vectorSettings.scaleFactor / 10;
  }

  public getScalarResult(modelId: string) {
    return this._model[modelId].modelSpec.fringesResultId;
  }

  public getVectorResult(modelId: string) {
    return this._model[modelId].modelSpec.vectorResultIdArray[0];
  }

  private setDefaults(modelId: string, type: any) {
    if (type === 'source') {
      this.setScalarResult(modelId, -1);
      for (const vector of this._vectorResultsWithNone[modelId]) {
        if (vector.name === 'fiberorientation_1') {
          this.setVectorResult(modelId, vector.id);
        }
      }
    }

    if (type === 'source') {
      this.setVectorResult(modelId, -1);
      for (const scalar of this._scalarResultsWithNone[modelId]) {
        if (scalar.name === 'X fiberorientation_1') {
          this.setScalarResult(modelId, scalar.id);
        }
      }
    }

    if (type === 'target') {
      this.setVectorResult(modelId, -1);
      for (const scalar of this._scalarResultsWithNone[modelId]) {
        if (scalar.name === 'matcherror') {
          this.setScalarResult(modelId, scalar.id);
        }
      }
    }
  }

  public removeModel() {
    console.log('c3 service');

    Object.entries(this._model).forEach(([key, value]) => {
      const modelId = key;
      this._view[modelId].removeAllModels();
      delete this._view[modelId];
      delete this._viewer[modelId];
      this._model[modelId].closeModel();
      delete this._model[modelId];
      delete this.observeModel[modelId];
      delete this.elementPicked[modelId];

      this._socket[modelId].disconnect();
      delete this._socket[modelId];
      console.log('close model: ' + modelId);
    });
  }
}
